import { Fragment, ReactNode } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { Float } from "@headlessui-float/react";

export interface IMenuItem {
  href?: string;
  icon?: ReactNode;
  label: string;
  target?: string;
  onClick?: () => void;
}

interface DropdownMenuProps {
  label: ReactNode;
  items: IMenuItem[];
  position?: "top" | "bottom" | "bottom-start";
  align?: "left" | "right";
  labelClassname?: string;
  transition?: boolean;
}

export const DropdownMenu = ({
  label,
  items,
  position = "bottom",
  align = "right",
  labelClassname,
}: DropdownMenuProps) => {
  return (
    <Menu as="div" className="relative w-fit text-left">
      <Float portal placement={position === "bottom" ? "bottom-end" : position === "top" ? "top-end" : position} flip>
        <div className="flex flex-col justify-center items-center">
          <Menu.Button
            className={twMerge("w-fit h-full outline-0", labelClassname)}
            onClick={(e) => e.stopPropagation()}
          >
            {label}
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={`z-10 my-2 min-w-36 w-max origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
          >
            <div className="divide-y divide-gray-100">
              {items.map(
                (
                  { icon, label, href, target, onClick }: IMenuItem,
                  index: number
                ) => (
                  <Menu.Item key={index}>
                    {href ? (
                      <Link
                        to={href}
                        className="flex items-center justify-start gap-x-2 px-4 py-3 text-sm hover:bg-gray-100 cursor-pointer"
                        target={target ?? "_self"}
                      >
                        {icon} <div className="shrink-0">{label}</div>
                      </Link>
                    ) : (
                      <div
                        className="flex items-center justify-start gap-x-2 px-4 py-3 text-sm hover:bg-gray-100 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClick && onClick();
                        }}
                      >
                        {icon} <div className="flex-1 break-words">{label}</div>
                      </div>
                    )}
                  </Menu.Item>
                )
              )}
            </div>
          </Menu.Items>
        </Transition>
      </Float>
    </Menu>
  );
};
